import { Fragment, useState } from 'react';
import cx from 'classnames';

import { numeric } from 'utils';
import { Input } from 'components/common/form/input';
import OPNBigIcon from 'components/icons/OPNBigIcon';
import OPNIcon from 'components/icons/OPNIcon';
import useValidateFields from 'lib/hooks/use-validate-fields';

import {
  StyledAmountInput,
  StyledBottomText,
  StyledTopText,
  StyledAmount,
  StyledError,
  StyledSign
} from './amount-with-max.style';

const AmountWithMax = ({ opnColor = '#329d9c', textButton = 'USE MAX' }) => {
  const [amount] = useState('4500');
  const [val, setValue] = useState('');
  const [balance] = useState('5642');
  const [max] = useState('10000');
  const { errors, setErrors, validate } = useValidateFields(amount);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (numeric(value)) {
      setValue(value);
      validate(name, value);
    }
  };

  const onClickHandler = () => {
    setValue(amount);
    setErrors({});
  };

  return (
    <Fragment>
      <StyledSign>
        <OPNBigIcon color={opnColor} />
        OPN
      </StyledSign>
      <StyledAmount>
        <StyledTopText>
          Current Pool: {amount} / {max}
        </StyledTopText>
        <StyledAmountInput
          className={cx({
            'is--error': 'amount' in errors
          })}
        >
          <Input
            type="text"
            variant="clearBold"
            name="amount"
            placeholder="0.0"
            inputMode="decimal"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            autoFocus
            className={cx({
              'is--error': 'amount' in errors
            })}
            onChange={onChangeHandler}
            value={val}
          />
          <button onClick={onClickHandler}>{textButton}</button>
        </StyledAmountInput>
        <StyledBottomText>
          <StyledError>
            {'amount' in errors && (
              <>
                <b>Error: </b>
                {errors?.amount}
              </>
            )}
          </StyledError>
          <StyledTopText right>
            <OPNIcon color="#58667e" />
            Balance: {balance}
          </StyledTopText>
        </StyledBottomText>
      </StyledAmount>
    </Fragment>
  );
};

export default AmountWithMax;
